// TODO update toastweb to remove this from its groovy template
// TODO delete this directive once toastweb no uses it
export function SchedulesDirective() {
    'ngInject';
    return {
        restrict: 'E',
        replace: false,
        link: function(scope, elem, attrs) {
        }
    };
}
